import React from "react";

import {
  MenuCtxWrapper,
  ButtonsWrapper,
  ButtonCtxWrapper,
  BtnText,
} from "./MainMenuContextStyles";
import { MenuButton } from "../UI/menuButton/MenuButton";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";
import { ReactComponent as CPUMode } from "../../assets/images/player-vs-cpu.svg";
import { ReactComponent as PVPMode } from "../../assets/images/player-vs-player.svg";
import { ReactComponent as ProfileIcon } from "../../assets/images/you.svg";
import { ReactComponent as RulesIcon } from "../../assets/images/icon-check.svg";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { startGame } from "../../store/gameSlice";
import { toggleModal } from "../../store/modalSlice";
import { useFarcaster } from "../../contexts/FarcasterContext";
import PlayerAvatar from "../multiplayer/PlayerAvatar";

const MainMenuContext: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user: farcasterUser } = useFarcaster();

  const gameRulesHandler = () => navigate("/rules");
  const CPUvPHandler = () => dispatch(toggleModal("mainMenu"));
  const multiplayerHandler = () => navigate("/multiplayer");
  const profileHandler = () => navigate("/profile");

  const displayName = farcasterUser?.displayName || farcasterUser?.username;

  return (
    <MenuCtxWrapper>
      <Logo />
      {farcasterUser && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.8rem",
            background: "rgba(255,255,255,0.1)",
            borderRadius: "10rem",
            padding: "0.4rem 1.2rem 0.4rem 0.4rem",
            cursor: "pointer",
            border: "1px solid rgba(255,255,255,0.2)",
          }}
          onClick={profileHandler}
        >
          <PlayerAvatar
            pfpUrl={farcasterUser.pfpUrl}
            name={displayName || "?"}
            size={28}
            ringColor="rgba(255,255,255,0.6)"
          />
          <span
            style={{ fontSize: "1.3rem", color: "white", fontWeight: "bold" }}
          >
            {farcasterUser.username
              ? `@${farcasterUser.username}`
              : farcasterUser.displayName
                ? farcasterUser.displayName
                : `FID #${farcasterUser.fid}`}
          </span>
        </div>
      )}
      <ButtonsWrapper>
        <MenuButton
          bgColor="yellow"
          textcolor="black"
          onClick={multiplayerHandler}
        >
          <ButtonCtxWrapper>
            <BtnText>multiplayer</BtnText>
            <PVPMode />
          </ButtonCtxWrapper>
        </MenuButton>
        <MenuButton bgColor="red" textcolor="white" onClick={CPUvPHandler}>
          <ButtonCtxWrapper>
            <BtnText>player vs cpu</BtnText>
            <CPUMode />
          </ButtonCtxWrapper>
        </MenuButton>
        <MenuButton bgColor="darkPurple" textcolor="white" onClick={() => navigate("/league")}>
          <ButtonCtxWrapper>
            <BtnText>AI Arena (League)</BtnText>
            <Logo style={{ width: "30px", height: "30px" }} />
          </ButtonCtxWrapper>
        </MenuButton>
        <MenuButton bgColor="purple" textcolor="white" onClick={profileHandler}>
          <ButtonCtxWrapper>
            <BtnText>profile & leaderboard</BtnText>
            <ProfileIcon />
          </ButtonCtxWrapper>
        </MenuButton>
        <MenuButton
          bgColor="white"
          textcolor="black"
          onClick={gameRulesHandler}
        >
          <ButtonCtxWrapper>
            <BtnText>game rules</BtnText>
            <RulesIcon />
          </ButtonCtxWrapper>
        </MenuButton>
      </ButtonsWrapper>
    </MenuCtxWrapper>
  );
};

export default MainMenuContext;
